import type { PayBalanceShop } from './types';

function toArray<T>(val: T | T[] | null | undefined): T[] {
  if (!val) return [];
  return Array.isArray(val) ? val : [val];
}

export function toPayBalanceShops(shops: Shop[], enabledShopIds: Set<string>): PayBalanceShop[] {
  return shops.map((shop) => {
    const relation = shop.Registers;
    let registers: Register[];
    if (!relation) {
      registers = [];
    } else if (!Array.isArray(relation) && 'Register' in relation) {
      registers = toArray((relation as { Register: Register | Register[] }).Register);
    } else {
      registers = toArray(relation as Register | Register[]);
    }
    return {
      shopID: shop.shopID,
      name: shop.name,
      registers: registers.map((r) => ({
        registerID: r.registerID,
        name: r.name,
        open: r.open === 'true',
        archived: r.archived === 'true',
        shopID: r.shopID,
      })),
      lsPayEnabled: enabledShopIds.has(shop.shopID),
    };
  });
}
